/* __next_internal_client_entry_do_not_use__ PROFILE_ACCORDION_SECTION_UIDS,default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Global
import { useRef } from 'react';
import { tv } from 'tailwind-variants';
// Local
import { useAccordionItemContext } from 'helpers/Context/AccordionContext';
import { SvgIcon } from 'helpers/SvgIcon';
export const PROFILE_ACCORDION_SECTION_UIDS = {
    expertise: 'profile-expertise',
    location: 'profile-location',
    membership: 'profile-membership'
};
const ProfileAccordionItem = ({ uid, title, children })=>{
    const accordionItemBodyRef = useRef(null);
    const { isOpening, toggleOpen } = useAccordionItemContext(uid, accordionItemBodyRef);
    const { accordionSection, accordionButton, accordionIcon, accordionContent, accordionContentInner } = TAILWIND_VARIANTS({
        isOpening
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: accordionSection(),
        "data-accordion-section": uid,
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                "aria-expanded": isOpening,
                onClick: ()=>toggleOpen(),
                className: accordionButton(),
                children: [
                    title ? /*#__PURE__*/ _jsx("span", {
                        className: "font-semibold",
                        children: title
                    }) : null,
                    /*#__PURE__*/ _jsx("span", {
                        className: accordionIcon(),
                        children: /*#__PURE__*/ _jsx(SvgIcon, {
                            fill: "none",
                            icon: "chevron-down",
                            size: "xs",
                            viewBox: "0 0 24 24"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: accordionItemBodyRef,
                className: accordionContent(),
                "aria-hidden": !isOpening,
                children: /*#__PURE__*/ _jsx("div", {
                    className: accordionContentInner(),
                    children: children
                })
            })
        ]
    });
};
export default ProfileAccordionItem;
const TAILWIND_VARIANTS = tv({
    slots: {
        accordionSection: [
            'border',
            'border-component-accordion-item-border',
            'rounded-component-accordion-item-border-radius',
            'bg-component-Profile-Block-surface',
            'overflow-hidden',
            'focus-within:shadow-[0_0_0_3px_var(--color-core-color-4-SkyBlue)]',
            'break-inside-avoid'
        ],
        accordionButton: [
            'cursor-pointer',
            'flex',
            'items-center',
            'justify-between',
            'w-full',
            'px-component-accordion-item-padding-x',
            'py-component-accordion-item-padding-y',
            'text-left',
            'text-color-core-color-1-Navy',
            'font-typography-font-family-body',
            'text-typography-font-size-body-large',
            'leading-typography-line-height-body-large',
            'focus:outline-none',
            'hover:underline',
            'group',
            '[&[aria-expanded="true"]]:pb-0',
            'duration-300',
            'ease-in-out'
        ],
        accordionIcon: [
            'transform',
            'transition-transform',
            'text-component-accordion-item-icon',
            'group-hover:text-component-accordion-item-icon-hover'
        ],
        accordionContent: [
            'grid',
            'overflow-hidden',
            'transition-[grid-template-rows]',
            'duration-300',
            'ease-in-out'
        ],
        accordionContentInner: [
            'min-h-0',
            'overflow-hidden'
        ]
    },
    variants: {
        isOpening: {
            true: {
                accordionContent: [
                    'grid-rows-[1fr]'
                ],
                accordionIcon: [
                    'rotate-180'
                ]
            },
            false: {
                accordionContent: [
                    'grid-rows-[0fr]'
                ],
                accordionIcon: []
            }
        }
    }
});
